<template>
    <admin-header />
    <admin-menu />
    <div class="flex sm:ml-20 mt-6 dark:text-dark.textOnBkg">
        <font-awesome-icon icon="fas fa-arrow-left" class="text-2xl mr-6 cursor-pointer mt-5" @click="$router.go(-1)" />
        <div>
            <MazSelect 
                v-model="selectedCompany"
                :options="companies_list"
                size="sm"
                label="Agency"
                optionValueKey="id"
                optionLabelKey="name"
                option-input-value-key="name"
                search
            /><br />
            <div class="cursor-pointer mt-1.5" @click="onlyActiveFunction">
                <div>
                    <font-awesome-icon :icon="onlyActive.icon" /> Show only active
                </div>
            </div>
        </div>
    </div>
    <div class="overflow-x-auto mx-auto mt-2 px-5 sm:pl-20 sm:pr-10">
        <div class="overflow-auto pb-20" style="height: calc(100vh - 155px);">
            <table
                class="bg-transparent dark:bg-dark.tableBG mt-3 mx-auto whitespace-nowrap rounded font-normal border border-sepBorder dark:border-dark.sepBorder table-auto w-full">
                <thead>
                    <tr class="top-0 sticky bg-gray-100 z-10 border border-sepBorder dark:bg-dark.panels dark:text-dark.textOnBkg">
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">ID</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">Name</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">Email</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">Position</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">Active</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">Suspended</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">Last active</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">Added at</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">Actions</th>
                    </tr>
                </thead>
                <tbody v-if="filteredEmployees.length > 0">
                    <slot v-for="(employee, index) in filteredEmployees" :key="index">
                        <tr class="dark:bg-dark.tableBG dark:text-dark.textOnBkg" :class="{'bg-gray-100 dark:bg-dark.tableRow1': index%2 == 1}">
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">{{ employee.id }}</td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">{{ employee.name }}</td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">{{ employee.email }}</td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">{{ employee.positionName }}</td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">
                                <font-awesome-icon v-if="employee.active" icon="fas fa-check" class="text-green-500" />
                            </td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">
                                <font-awesome-icon v-if="employee.suspended == 1" icon="fas fa-circle-pause" class="text-orange-500" />
                            </td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center font-semibold">{{ lastActiveDays(employee.lastActive) }}</td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">{{ $moment(employee.createdAt).format("DD.MM.YYYY HH:MM") }}</td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center whitespace-nowrap">
                                <div @click="accessAsUser(employee.id)" class="cursor-pointer text-xs p-0.5 px-1 rounded bg-button text-white mx-1">Access as user <font-awesome-icon icon="fa-solid fa-arrow-up-right-from-square" /></div>
                            </td>
                        </tr>
                    </slot>
                </tbody>
                <tbody v-else-if="!loading">
                    <tr>
                        <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center" colspan="7">
                            <span v-if="!selectedCompany">Please select a company first</span>
                            <span v-else>No employees found</span>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="7" class="text-center py-16 dark:text-dark.textOnBkg">
                            <font-awesome-icon icon="fas fa-spinner" class="animate-spin text-xl text-center" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script setup>
    import adminHeader from '@/components/admin/AdminHeader.vue';
    import adminMenu from '@/components/admin/AdminMenu.vue';
</script>
  
<script>
    import { getEmployees, getCompanies, fetchEmployeeUserToken } from '@/api/admin_api';
    export default {
        name: 'EmployeesDashboard',
        data() {
            return {
                employees_list: [],
                selectedCompany: 0,
                onlyActive: {
                    icon: 'fas fa-square-check',
                    active: true
                },
                hideSuspended: {
                    icon: 'fas fa-square-check',
                    active: true
                },
                loading: false,
                companies_list: []
            }
        },
        computed: {
            filteredEmployees() {
                if (this.onlyActive.active) {
                    if (this.hideSuspended.active) {
                        return this.employees_list.filter(creator => creator.active && creator.suspended == 0);
                    } else {
                        return this.employees_list.filter(creator => creator.active);
                    }
                }
                if (this.hideSuspended.active) {
                    return this.employees_list.filter(creator => creator.suspended == 0);
                }
                return this.employees_list;
            }
        },
        watch: {
            selectedCompany: function() {
                this.getEmployees_list();
            },
        },
        methods: {
            async accessAsUser(employeeId) {
                //fetch Token
                await fetchEmployeeUserToken(this.$cookies.get('admin_auth_token'), employeeId).then((response) => {
                    if (response.success) {
                        this.$cookies.set('userToken', response.token, { path: '/' });
                        this.$cookies.remove('c_id');
                        //open the page in a new window /profile
                        window.open('/profile', '_blank');
                    } else {
                        alert(response.message);
                    }
                }).catch((error) => {
                    alert('Error fetching token: ' + error);
                });
            },
            lastActiveDays(lastActive) {
                if (lastActive) {
                    const now = this.$moment();
                    const lastActiveDate = this.$moment(lastActive);
                    const diff = now.diff(lastActiveDate, 'days');
                    return diff == 0 ? 'Today' : diff + (diff == 1 ? ' day ' : ' days ') + 'ago';
                }
                return null;
            },
            removeSuspended() {
                this.hideSuspended.active = !this.hideSuspended.active;
                this.hideSuspended.icon = this.hideSuspended.active ? 'fas fa-check-square' : 'far fa-square';
            },
            onlyActiveFunction() {
                this.onlyActive.active = !this.onlyActive.active;
                this.onlyActive.icon = this.onlyActive.active ? 'fas fa-check-square' : 'far fa-square';
            },
            isTrialPeriod(trialEndDate) {
                return this.$moment(trialEndDate).isSameOrAfter(this.$moment());
            },
            async getEmployees_list() {
                this.loading = true;
                if (!this.selectedCompany) { return; }
                await getEmployees(this.$cookies.get('admin_auth_token'), this.selectedCompany).then((response) => {
                    this.employees_list = response;
                    this.loading = false;
                });
            },
        },
        created() {
            this.loading = true;
            getCompanies(this.$cookies.get('admin_auth_token')).then((response) => {
                this.companies_list = response;
                this.loading = false;
            });

            if (this.$route.query.company) {
                this.selectedCompany = parseInt(this.$route.query.company);
                this.getEmployees_list();
            }
        }
    };
</script>